import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewManagerComp from "./Component/ViewManagerComp"


const ViewManager = () => {
    return (
        <>
            <Navbar />
            <div className="d-flex mainContentArea">
                <Sidebar />
                <ViewManagerComp />

            </div>
            <Footer />
        </>
    )
}

export default ViewManager